module.exports = __webpack_public_path__ + "img/Magazine.b790aa7b.jpg";